export const formatOptions = {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'symbol'
}
